export const initialState = {
    user: null,
    playlists: [],
    playing: false,
    item: null,
    // token:'BQDWU8geJWRy45J8CMXxCzmppdPDlsXjkF1Cd3ysaaXHMDFc0PSntg70oSXNzcHCXOhTETmdeHnqN1a-wu747DZpgSJkbI1nK7V-3LeZHDWvdhevO9TOz9bAyYedE7AhVuzpxebbexuWJ0IjimUtWebIfScmjjIM48ltekXPB45yu-CG'
}

const reducer = (state,action) => {
console.log(action);

    switch(action.type){
        case 'SET_USER':
            return{
                ...state,
                user: action.user
            }
        case 'SET_TOKEN':
            return{
                ...state,
                token: action.token
            }
        case 'SET_PLAYLISTS':
            return{
                ...state,
                playlists: action.playlists
            }
        case 'SET_DISCOVER_WEEKLY':
            return{
                ...state,
                discover_weekly: action.discover_weekly
            }
        default:
            return state;
    }
}
export default reducer;